import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { withTranslation } from "react-i18next";
import styles from "./../../../../pages/CredentialsAndLicensing/Credentials.module.scss";
import officePolicyStyles from "../OfficePolicyManagement.module.scss";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import EmployeeSelection from "../../../../pages/CredentialsAndLicensing/EmployeeSelection";
import { useRenewPolicyMutation } from "repositories/office-policy-management-repository";
import toast from "react-hot-toast";
import Loader from "components/Loader";
import { MoreTagsFunction } from "accountOwner/pages/AddEvent/addEvents.functions";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import usePolicyModuleListing from "../hooks/usePolicyModuleListing";
import ReactDatePickerCommon from "components/ReactDatePickerCommon";
import CustomDropdown from "components/Dropdown";
import SelectPolicyModal from "./SelectPolicyModal";
import RolePopup from "accountOwner/pages/AddEvent/components/RolePopup";
import moment from "moment";
import { scrollToError } from "utils";
import { Tooltip } from "reactstrap";
// Updated Checkbox to use classes
const CustomCheckbox = ({ label, checked, onChange }) => {
  return (
    <label className={officePolicyStyles["checkbox-label"]+" ch-checkbox c-field"}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className={officePolicyStyles["checkbox-input"]}
      />
      <span className={officePolicyStyles["checkbox-text"]}>{label}</span>
    </label>
  );
};

// Updated Icon to use classes
const InfoIcon = ({onIconClick,customId}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={officePolicyStyles["info-icon"]}
    onClick={onIconClick}
    id={customId}
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);

const isRenewablePolicy = (policy) => {
  if (!policy) return false;
  if (policy.isDraft ?? policy.IsDraft) return false;
  const assignees = (policy.assignees ?? policy.Assignees ?? "").trim();
  return assignees !== "";
};

const RenewAcknowledgement = ({ t }) => {
  const history = useHistory();
  const location = useLocation();
  const listFromArchived = location.state?.renewFromArchived === true;
  const { officePolicies } = usePolicyModuleListing(listFromArchived, true);
  const preselectedFoldersAppliedRef = useRef(false);
  const { selectedId,getIdToCheckOwnerChange } = useAccountOwnerCommon();
  const [invitePopupOpen, setInvitePopupOpen] = useState(false);
  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });
  const [startDate, setStartDate] = useState(new Date());
  const [dueDate, setDueDate] = useState(moment().add(1, 'day').toDate());
  const [notifyAssignees, setNotifyAssignees] = useState(false);
  const [notifyManagement, setNotifyManagement] = useState(false);
  const [managementOption, setManagementOption] = useState(true);
  const [remindAfterPublish, setRemindAfterPublish] = useState(false);
  const [remindAfterPublishDays, setRemindAfterPublishDays] = useState(0);
  const [remindBeforeDueDate, setRemindBeforeDueDate] = useState(false);
  const [remindBeforeDueDateDays, setRemindBeforeDueDateDays] = useState(0);
  const [createTask, setCreateTask] = useState(false);
  const [isSelectPolicyModalOpen, setIsSelectPolicyModalOpen] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState([]);
  const [policyPopupOpen, setPolicyPopupOpen] = useState(false);
  const handlePopupToggle = (event, setter) => {
    event.stopPropagation();
    setInvitePopupPosition({
      top: 40,
      left: 40,
    });
    setter((prev) => !prev);
  };
  const [tooltipOpen, setTooltipOpen] = useState({
    notifyAssignees: false,
    notifyManagement: false,
    remindAfterPublish: false,
    remindBeforeDueDate: false,
    createTask: false,
  });
  const toggleTooltip = useCallback((key) => {
    setTooltipOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

  const renewPolicyMutation = useRenewPolicyMutation();

  const [isSelectStaffMemberModalOpen, setIsSelectStaffMemberModalOpen] =
    useState(false);

  const [selectedStaffMemberIds, setSelectedStaffMemberIds] = useState([]);
  const [error, setError] = useState(null);
  useEffect(() => {
    if(getIdToCheckOwnerChange()) {
      history.goBack();
    }
  }, [selectedId]);

  /** Pre-select policies when opened from Compliance Dashboard (global menu) with row selection. */
  useEffect(() => {
    const folderIds = location.state?.renewPreselectedFolderIds;
    if (!Array.isArray(folderIds) || folderIds.length === 0) return;
    if (preselectedFoldersAppliedRef.current) return;
    if (!officePolicies?.length) return;
    preselectedFoldersAppliedRef.current = true;
    const idSet = new Set(folderIds.map((id) => Number(id)));
    const matched = officePolicies.filter((p) => idSet.has(Number(p.id)));
    const matchedEligiblePolicies = matched.filter(isRenewablePolicy);
    if (matchedEligiblePolicies.length > 0) {
      setSelectedPolicy(matchedEligiblePolicies);
    }
  }, [location.state, officePolicies]);
  const isValidate = () => {
    const errors = {};
    let isValid = true;
    if (selectedPolicy.length === 0) {
      errors.policyError = t("officePolicyManagement.pleaseSelectAtLeastOnePolicy");
      isValid = false;
    }
    if (
      notifyManagement &&
      !managementOption &&
      selectedStaffMemberIds.length === 0
    ) {
      errors.managementMembersError =
        t("officePolicyManagement.pleaseSelectAtLeastOneManagementMember");
      isValid = false;
    }
    if (
      moment(dueDate).startOf("day").isSameOrBefore(moment(startDate).startOf("day"))
    ) {
      errors.dueDateError = "Due date should be greater than the start date.";
      isValid = false;
    } else{
      if(remindAfterPublish&&!remindAfterPublishDays) {
        errors.remindAfterPublishDaysError = t("officePolicyManagement.remindAfterPublishShouldBeSelected");
        isValid = false;
      }else if(remindAfterPublish&&remindAfterPublishDays<=0) {
        errors.remindAfterPublishDaysError = t("officePolicyManagement.remindAfterPublishDaysShouldBeSelected");
        isValid = false;
      }
      if(remindBeforeDueDate&&!remindBeforeDueDateDays) {
        errors.remindBeforeDueDateDaysError = t("officePolicyManagement.remindAfterPublishShouldBeSelected");
        isValid = false;
      }else if(remindBeforeDueDate&&remindBeforeDueDateDays<=0) {
        errors.remindBeforeDueDateDaysError = t("officePolicyManagement.remindBeforeDueDateDaysShouldBeSelected");
        isValid = false;
      }
    }
    setError(errors);
    return isValid;
  };
  const submitRef = useRef(null);
  useEffect(() => {
    if (submitRef.current) {
      submitRef.current = !isValidate();
    }
  }, [
    selectedPolicy,
    startDate,
    dueDate,
    notifyManagement,
    managementOption,
    selectedStaffMemberIds,
    remindAfterPublish,
    remindBeforeDueDate,
    remindAfterPublishDays,
    remindBeforeDueDateDays,
  ]);
  const {
    remindAfterPublishDaysArray,
remindBeforeDueDateDaysArr
  }=useMemo(() => {
    const selectDays=[
      { id: "1", name: "1" },
      { id: "2", name: "2" },
      { id: "3", name: "3" },
      { id: "4", name: "4" },
      { id: "5", name: "5" },
    ]
    let remindAfterPublishDaysArray=[];
    let remindBeforeDueDateDaysArr=[];
    if(moment(dueDate).startOf('day').isSameOrBefore(moment(startDate).startOf('day'))&&remindAfterPublishDays) {
      setRemindAfterPublishDays(0);
      remindAfterPublishDaysArray=[];
    }
    if(moment(dueDate).startOf('day').isSameOrBefore(moment().startOf('day'))&&remindBeforeDueDateDays) {
      setRemindBeforeDueDateDays(0);
      remindBeforeDueDateDaysArr=[];
    }
    // const days=moment(dueDate).endOf('day').diff(moment(startDate).startOf('day'), 'days');
    const days=moment(dueDate).endOf('day').diff(moment(startDate).startOf('day'), 'days');
    if(days>0) {
      if(!remindAfterPublishDays||remindAfterPublishDays>days) {
            setRemindAfterPublishDays(Math.min(5,days));
          }
      remindAfterPublishDaysArray=selectDays.slice(0, days);
    }
    const beforeDueDateDays=moment(dueDate).endOf('day').diff(moment().startOf('day'), 'days');
    if(beforeDueDateDays>0) {
            if(!remindBeforeDueDateDays||remindBeforeDueDateDays>beforeDueDateDays) {
        setRemindBeforeDueDateDays(Math.min(5,beforeDueDateDays));
      }
      remindBeforeDueDateDaysArr=selectDays.slice(0, beforeDueDateDays);
    }
    return {
      remindAfterPublishDaysArray,
remindBeforeDueDateDaysArr
    };
  }, [startDate, dueDate, remindAfterPublishDays, remindBeforeDueDateDays]);

  const handleSave = async () => {
    try {
      if (!isValidate()) {
        submitRef.current = true;
        scrollToError()
        return;
      }
      const payload = {
        PolicyIds: selectedPolicy.map((res) => res.policyId),
        StartDate: moment(startDate).format("YYYY-MM-DD"),
        DueDate: moment(dueDate).format("YYYY-MM-DD"),
        NotifyAssignee: notifyAssignees,
        NotifyManagement: notifyManagement,
        RemindAfterPublish: remindAfterPublish?remindAfterPublishDays:null,
        RemindBeforeDueDate: remindBeforeDueDate?remindBeforeDueDateDays:null,
        IsNotifyAllManagementMember: managementOption,
        ManagerUsers: managementOption
          ? []
          : selectedStaffMemberIds.map((res) => ({ UserId: res.userId })),
        IsCreateTask: createTask,
      };
       await renewPolicyMutation.mutateAsync(payload);
       toast.success(t("officePolicyManagement.policyRenewedSuccessfully"));
       history.goBack();
    } catch (error) {
      toast.error(
        error.message || t("officePolicyManagement.policyRenewedFailed"),
      );
    }
  };

  const isLoading = renewPolicyMutation.isLoading;

  return (
    <div className={styles.pageContainer}>
      <div className={styles.backBtnContainer}>
        <button className="back-btn" onClick={() => history.goBack()}>
          <div className="back-btn-text">
            <span className="ico">
              <img
                src={require("assets/images/arrow-back-icon.svg").default}
                alt="arrow"
              />
            </span>
            {t("back")}
          </div>
        </button>
        <h2 className="page-title mb-0">
          {t("officePolicyManagement.renewAcknowledgement")}
        </h2>
      </div>
      {isLoading && <Loader />}
      <main
        className={styles.card}
        style={{ border: "none", boxShadow: "none" }}
      >
        <div className={officePolicyStyles["renew-acknowledgement-box"]}>
          {/* Policy Section */}
          <div className={`${officePolicyStyles["section-header"]}`}>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <label className={officePolicyStyles["field-label"]}>
                  {t("officePolicyManagement.policy")}
                </label>
                <div
                  className={
                    "c-form-control " + officePolicyStyles["field-value"]
                  }
                  style={{ position: "relative" }}
                >
                  <span>
                    {selectedPolicy.length === 0 ? (
                      t("officePolicyManagement.noPoliciesSelected")
                    ) : (
                      <MoreTagsFunction
                        value={selectedPolicy}
                        styles={styles.link_new}
                        clickHandler={(e) =>
                          handlePopupToggle(e, setPolicyPopupOpen)
                        }
                        mapFn={(member) => member?.title}
                      />
                    )}
                  </span>
                  {policyPopupOpen && (
                    <RolePopup
                      handlePopupToggle={(e) =>
                        handlePopupToggle(e, setPolicyPopupOpen)
                      }
                      position={invitePopupPosition}
                      list={selectedPolicy.map((res) => ({
                        name: res.title,
                        id: res.id,
                      }))}
                      isForEvent={true}
                    />
                  )}
                </div>
              </div>
              {/* </div> */}
              <span
                onClick={() => setIsSelectPolicyModalOpen(true)}
                className={officePolicyStyles["select-btn"]}
              >
                {t("officePolicyManagement.select")}
              </span>
            </div>
            {error?.policyError && (
              <span className="error-msg">{error.policyError}</span>
            )}
          </div>
          {isSelectPolicyModalOpen && (
            <SelectPolicyModal
              t={t}
              issaveEmployeeModalOpen={isSelectPolicyModalOpen}
              setIsSaveEmployeeModalOpen={setIsSelectPolicyModalOpen}
              policiesIds={selectedPolicy}
              setPoliciesIds={setSelectedPolicy}
            />
          )}

          {/* Date Section */}
          <div className={`d-flex mb-5 ${officePolicyStyles["date-row"]}`}>
            <div className={`w-100 ${officePolicyStyles["date-col"]} c-field mb-0`}>
              <label className={officePolicyStyles["field-label"]}>
                {t("officePolicyManagement.startDate")}
              </label>
              <div className="d-flex justify-content-between align-items-center inputdate">
                <ReactDatePickerCommon
                  dateFormat="dd-MM-yyyy"
                  className={`c-form-control border-0 p-0 shadow-none  ${officePolicyStyles["date-picker-input"]}`}
                  onChange={(e) => setStartDate(e)}
                  selected={startDate}
                />
              </div>
              {error?.startDateError && (
                <span className="error-msg">{error.startDateError}</span>
              )}
            </div>
            <div className={`w-100 ${officePolicyStyles["date-col"]} c-field mb-0`}>
              <label className={officePolicyStyles["field-label"]}>
                {t("officePolicyManagement.dueDate")}
              </label>
              <div className="d-flex justify-content-between align-items-center inputdate">
                <ReactDatePickerCommon
                  dateFormat="dd-MM-yyyy"
                  className={`c-form-control border-0 p-0 shadow-none  ${officePolicyStyles["date-picker-input"]}`}
                  onChange={(e) => setDueDate(e)}
                  selected={dueDate}
                  minDate={moment(startDate).startOf('day').isSameOrAfter(moment().startOf('day'))?moment(startDate).add(1, 'day').toDate():new Date()}
                />
              </div>
              {error?.dueDateError && (
                <span className="error-msg">{error.dueDateError}</span>
              )}
            </div>
          </div>

          <div className={styles.panel__body}>
            {/* Notify Assignees */}
            <div className="mb-3">
              <CustomCheckbox
                label={
                  <>
                    {t("officePolicyManagement.notifyAssignees")} <InfoIcon onIconClick={() => toggleTooltip("notifyAssignees")} customId="TooltipNotifyAssignees" />
                  </>
                }
                checked={notifyAssignees}
                onChange={() => setNotifyAssignees(!notifyAssignees)}
              />
                              <Tooltip
                  className="new-item-card-catalogue-tooltip"
                  isOpen={tooltipOpen.notifyAssignees}
                  placement="top"
                  target="TooltipNotifyAssignees"
                  toggle={() => toggleTooltip("notifyAssignees")}
                >
                  {t("officePolicyManagement.notifyAssigneesTooltip")}
                </Tooltip>
            </div>

            {/* Notify Management */}
            <div className="mb-3">
              <CustomCheckbox
                label={
                  <>
                    {t("officePolicyManagement.notifyManagement")} <InfoIcon onIconClick={() => toggleTooltip("notifyManagement")} customId="TooltipNotifyManagement" />
                  </>
                }
                checked={notifyManagement}
                onChange={() => setNotifyManagement(!notifyManagement)}
              />
                              <Tooltip
                  className="new-item-card-catalogue-tooltip"
                  isOpen={tooltipOpen.notifyManagement}
                  placement="top"
                  target="TooltipNotifyManagement"
                  toggle={() => toggleTooltip("notifyManagement")}
                >
                  {t("officePolicyManagement.notifyManagementTooltip")}
                </Tooltip>

              {notifyManagement && (
                <div className={officePolicyStyles["nested-container"]}>
                  <label className={officePolicyStyles["radio-label"]}>
                    <input
                      type="radio"
                      name="managementOption"
                      checked={managementOption}
                      onChange={() => setManagementOption(true)}
                      className={officePolicyStyles["radio-input"]}
                    />
                    {t("officePolicyManagement.allMembers")}
                  </label>

                  <div className={officePolicyStyles["nested-section-border"]}>
                    <div className="d-flex justify-content-between align-items-center">
                      <label
                        className={`mb-0 border-0 pb-0 ${officePolicyStyles["radio-label"]}`}
                      >
                        <input
                          type="radio"
                          name="managementOption"
                          checked={!managementOption}
                          onChange={() => setManagementOption(false)}
                          className={officePolicyStyles["radio-input"]}
                        />
                        {t("officePolicyManagement.selectedMembers")}
                      </label>
                      {!managementOption && (
                        <span
                          onClick={() => setIsSelectStaffMemberModalOpen(true)}
                          className={officePolicyStyles["select-btn"]}
                        >
                          {t("officePolicyManagement.select")}
                        </span>
                      )}
                    </div>

                    {!managementOption&&notifyManagement && (
                      <div
                        className={officePolicyStyles["selected-members-box"]+" position-relative"}
                      >
                        <strong className={officePolicyStyles["member-text"]}>
                          {selectedStaffMemberIds.length === 0 ? (
                            <span className={` ${styles["nomember"]} `}>
                              {t("officePolicyManagement.noMembersSelected")}
                            </span>
                          ) : (
                            <MoreTagsFunction
                              value={selectedStaffMemberIds}
                              parentClass={styles.moreTagsFunctionParent}
                              styles={styles.link_new}
                              clickHandler={(e) =>
                                handlePopupToggle(e, setInvitePopupOpen)
                              }
                              mapFn={(member) =>
                                member?.userName ||
                                [
                                  member?.user?.firstName,
                                  member?.user?.lastName,
                                ]
                                  .filter(Boolean)
                                  .join(" ")
                              }
                            />
                          )}
                        </strong>
                        {invitePopupOpen && (
                          <InviteesPopup
                            position={invitePopupPosition}
                            handleInvitePopupToggle={(e) =>
                              handlePopupToggle(e, setInvitePopupOpen)
                            }
                            list={selectedStaffMemberIds}
                            showRoleAndOffice={false}
                            isForEvent={true}
                            parentClass={styles.invitePopupParent}
                            listClass={styles.invitePopupListClass}
                          />
                        )}
                      </div>
                    )}
                    {error?.managementMembersError && (
                      <span className="error-msg">{error.managementMembersError}</span>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Remind After Publish */}
            <div className="mb-3 mt-4">
              <CustomCheckbox
                label={
                  <>
                    {t("officePolicyManagement.remindAfterPublish")} <InfoIcon onIconClick={() => toggleTooltip("remindAfterPublish")} customId="TooltipRemindAfterPublish" />
                  </>
                }
                checked={remindAfterPublish}
                onChange={() => setRemindAfterPublish(!remindAfterPublish)}
              />
                              <Tooltip
                  className="new-item-card-catalogue-tooltip"
                  isOpen={tooltipOpen.remindAfterPublish}
                  placement="top"
                  target="TooltipRemindAfterPublish"
                  toggle={() => toggleTooltip("remindAfterPublish")}
                >
                  {t("officePolicyManagement.remindAfterPublishTooltip")}
                </Tooltip>
              {remindAfterPublish && (
                <div
                  className={`${officePolicyStyles["nested-container"]} ${officePolicyStyles["nested-section-border"]}`}
                >
                  <label className={officePolicyStyles["field-label"]}>
                    {t("officePolicyManagement.noOfDays")}
                  </label>
                  <div
                    className={`custom-dropdown-only ${officePolicyStyles["dropdown-container"]}`}
                  >
                    <CustomDropdown
                      options={remindAfterPublishDaysArray}
                      selectedOption={remindAfterPublishDays.toString()}  
                      defaultValue={remindAfterPublishDays.toString()}
                      selectOption={(id) => {
                        setRemindAfterPublishDays(id);
                      }}
                    />
                  </div>
                  {error?.remindAfterPublishDaysError && (
                    <span className="error-msg">{error.remindAfterPublishDaysError}</span>
                  )}
                </div>
              )}
            </div>

            {/* Remind Before Due Date */}
            <div className="mb-3 mt-4">
              <CustomCheckbox
                label={
                  <>
                    {t("officePolicyManagement.remindBeforeDueDate")} <InfoIcon onIconClick={() => toggleTooltip("remindBeforeDueDate")} customId="TooltipRemindBeforeDueDate" />
                  </>
                }
                checked={remindBeforeDueDate}
                onChange={() => setRemindBeforeDueDate(!remindBeforeDueDate)}
              />
              <Tooltip
                  className="new-item-card-catalogue-tooltip"
                  isOpen={tooltipOpen.remindBeforeDueDate}
                  placement="top"
                  target="TooltipRemindBeforeDueDate"
                  toggle={() => toggleTooltip("remindBeforeDueDate")}
                >
                  {t("officePolicyManagement.remindBeforeDueDateTooltip")}
                </Tooltip>
              {remindBeforeDueDate && (
                <div
                  className={`${officePolicyStyles["nested-container"]} ${officePolicyStyles["nested-section-border"]}`}
                >
                  <label className={officePolicyStyles["field-label"]}>
                    {t("officePolicyManagement.noOfDays")}
                  </label>
                  <div
                    className={`custom-dropdown-only ${officePolicyStyles["dropdown-container"]}`}
                  >
                    <CustomDropdown
                      options={remindBeforeDueDateDaysArr}
                      selectedOption={remindBeforeDueDateDays.toString()}
                      defaultValue={remindBeforeDueDateDays.toString()}
                      selectOption={(id) => {
                        setRemindBeforeDueDateDays(id);
                      }}
                    />
                  </div>
                  {error?.remindBeforeDueDateDaysError && (
                    <span className="error-msg">{error.remindBeforeDueDateDaysError}</span>
                  )}
                </div>
              )}
            </div>

            {/* Create Task */}
            <div className="mb-0 mt-4">
              <CustomCheckbox
                label={
                  <>
                    {t("officePolicyManagement.createTaskForAssignees")} <InfoIcon onIconClick={() => toggleTooltip("createTask")} customId="TooltipCreateTask" />
                  </>
                }
                checked={createTask}
                onChange={() => setCreateTask(!createTask)}
              />
              <Tooltip
                  className="new-item-card-catalogue-tooltip"
                  isOpen={tooltipOpen.createTask}
                  placement="top"
                  target="TooltipCreateTask"
                  toggle={() => toggleTooltip("createTask")}
                >
                  {t("officePolicyManagement.createTaskForAssigneesTooltip")}
                </Tooltip>
            </div>
          </div>
        </div>

        {/* Action Buttons wrapped with classes */}
        <div
          className={`d-flex ${styles["credentials-cta-box"]} ${officePolicyStyles["policy-cta-box"]}`}
        >
          <button
            onClick={handleSave}
            disabled={isLoading}
            className={officePolicyStyles["btn-save"]}
          >
            {isLoading ? t("accountOwner.saving") : t("save")}
          </button>
          <button
            onClick={() => history.goBack()}
            title={t("cancel")}
            className={officePolicyStyles["btn-cancel"]}
          >
            {t("cancel")}
          </button>
        </div>
      </main>
      {/* )} */}

      {isSelectStaffMemberModalOpen && (
        <EmployeeSelection
          issaveEmployeeModalOpen={"office"}
          setIsSaveEmployeeModalOpen={setIsSelectStaffMemberModalOpen}
          memberIds={selectedStaffMemberIds}
          setMemberIds={setSelectedStaffMemberIds}
          ownerId={selectedId}
          hideFilter={false}
        />
      )}
    </div>
  );
};

export default withTranslation()(RenewAcknowledgement);
